"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UcContractTerms = exports.ContractTermEditor = void 0;
const ContractTermEditor_yaml_component_1 = __importDefault(require("./ContractTermEditor.yaml?component"));
exports.ContractTermEditor = ContractTermEditor_yaml_component_1.default;
const UcContractTerms_yaml_component_1 = __importDefault(require("./UcContractTerms.yaml?component"));
exports.UcContractTerms = UcContractTerms_yaml_component_1.default;
